import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min"
import { checkMyDetails } from "../reduxs/actions";
import * as Mui from "@material-ui/core";
import { IconIzy } from "../components/svg";
import { useTranslation } from "react-i18next";

export default function NavigateWithAccessToken() {

    const { accessToken } = useParams()
    const history = useHistory();

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleCheckMyDetails = useCallback(() => {
        dispatch(checkMyDetails(accessToken, history));
    }, [accessToken, history, dispatch]);

    useEffect(() => {
        if (accessToken) {
            handleCheckMyDetails();
        }
    }, [handleCheckMyDetails, accessToken]);

    return (
        <Mui.Box className="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
            <Mui.Box className="d-flex" flexDirection="column" alignItems="center" justifyContent="center">
                <IconIzy width={150} height={150} fill="#000330" />
                <Mui.CircularProgress color="#000330" />
                <Mui.Typography variant="h4" component="h6" className="text-center mt-4 font-weight-medium">{t("ORGANIZATION.VALIDATING_TOKEN")}</Mui.Typography>
            </Mui.Box>
        </Mui.Box>
    )
}